import { httpClient } from "../http-client"

export const uploadAudioAssessmentRecording = async (
    URL: string,
    audioFile: any,
    headers: any
) => {
    const response = httpClient.put(URL, audioFile, {
        headers: headers,
    })
    if (response) {
        return response
    }
    return null
}
export const uploadDocument = async (URL: string, document: any, headers: any) => {
    const response = httpClient.put(URL, document, {
        headers: headers,
    })
    if (response) {
        return response
    }
    return null
}
